import ApiService from '../_shared/api/apiService';
import Singleton from '../Singleton';

export default class ListService extends Singleton<ListService> {
  // Returns a list of the authenticated user filter lists
  public getList = async tradeState => {
    const client = await ApiService();

    try {
      const listResponse = await client.apis.list.listLists({
        request: {
          tradeState
        }
      });

      return listResponse?.body;
    } catch (e) {
      throw new Error(e);
    }
  };

  public getMetaData = async () => {
    const client = await ApiService();

    try {
      const listResponse = await client.apis.list.listMetadata();

      return listResponse?.body;
    } catch (e) {
      throw new Error(e);
    }
  };

  public deleteList = async id => {
    const client = await ApiService();

    try {
      const listResponse = await client.apis.list.deleteList({
        id
      });

      return listResponse?.body;
    } catch (e) {
      throw new Error(e);
    }
  };

  public getSortMetaData = async () => {
    const client = await ApiService();

    try {
      const tradeResponse = await client.apis.trade.tradeMetadata();

      return tradeResponse?.body;
    } catch (e) {
      throw new Error(e);
    }
  };
}
